var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInformation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icon_INFORMATION"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_INFORMATION",
    clipPath: "url(#clip-Icon_INFORMATION)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NOTIF._INFORMATION",
    "data-name": "NOTIF. INFORMATION"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_9602",
    "data-name": "Rechteck 9602",
    width: 48,
    height: 48,
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pfad_7620",
    "data-name": "Pfad 7620",
    transform: "translate(6 6)",
    fill: "#007bff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18 35 C 13.45913982391357 35 9.190059661865234 33.231689453125 5.979189872741699 30.02080917358398 C 2.768310070037842 26.80994033813477 1 22.54085922241211 1 18 C 1 13.45913982391357 2.768310070037842 9.190059661865234 5.979189872741699 5.979189872741699 C 9.190059661865234 2.768310070037842 13.45913982391357 1 18 1 C 22.54085922241211 1 26.80994033813477 2.768310070037842 30.02080917358398 5.979189872741699 C 33.231689453125 9.190059661865234 35 13.45913982391357 35 18 C 35 22.54085922241211 33.231689453125 26.80994033813477 30.02080917358398 30.02080917358398 C 26.80994033813477 33.231689453125 22.54085922241211 35 18 35 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18 2 C 13.72624969482422 2 9.70829963684082 3.664291381835938 6.686290740966797 6.686290740966797 C 3.664291381835938 9.70829963684082 2 13.72624969482422 2 18 C 2 22.27375030517578 3.664291381835938 26.29170036315918 6.686290740966797 29.3137092590332 C 9.70829963684082 32.33570861816406 13.72624969482422 34 18 34 C 22.27375030517578 34 26.29170036315918 32.33570861816406 29.3137092590332 29.3137092590332 C 32.33570861816406 26.29170036315918 34 22.27375030517578 34 18 C 34 13.72624969482422 32.33570861816406 9.70829963684082 29.3137092590332 6.686290740966797 C 26.29170036315918 3.664291381835938 22.27375030517578 2 18 2 M 18 0 C 27.94112014770508 0 36 8.058879852294922 36 18 C 36 27.94112014770508 27.94112014770508 36 18 36 C 8.058879852294922 36 0 27.94112014770508 0 18 C 0 8.058879852294922 8.058879852294922 0 18 0 Z",
    stroke: "none",
    fill: "#007bff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(22 15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_38",
    "data-name": "Pfad 38",
    d: "M25,23V21H21v2h2v8H21v2h6V31H25Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_39",
    "data-name": "Pfad 39",
    d: "M24,6A18,18,0,1,0,42,24,18,18,0,0,0,24,6Zm0,34A16,16,0,1,1,40,24,16.018,16.018,0,0,1,24,40Z",
    fill: "none"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInformation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/information.544da81f60a0cfae4d3767b6025777fa.svg";